/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiLoadingElastic } from '@elastic/eui'

import { getConfigForKey } from '../../store'

import UserConsoleAppLoadingRoot from './UserConsoleAppLoadingRoot'

import type { FunctionComponent } from 'react'

const AppLoadingRoot: FunctionComponent = () => {
  const isAnyUserConsole = getConfigForKey(`APP_NAME`) === `userconsole`

  if (isAnyUserConsole) {
    return <UserConsoleAppLoadingRoot />
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginLeft: '-16px',
        marginTop: '-19px',
      }}
      className='app-loading'
      data-test-id='app-loading'
    >
      <EuiLoadingElastic size='xxl' />
    </div>
  )
}

export default AppLoadingRoot
